import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const TICKER_TEXT =
  '🏆 WIN A FREE SIM RACING EXPERIENCE — FREE MONTHLY DRAW   ·   WIN A PRO SIM RIG FOR £5 — 6-MONTHLY DRAW   ·   ENTER NOW   ·   ';

// Fixed promotional ticker that sits above the navbar. AppLayout owns its
// visibility (session-dismissable) and shifts the navbar + page content down
// so nothing overlaps.
export default function CompetitionTicker({ onClose }) {
  return (
    <div className="fixed top-0 left-0 right-0 z-[55] h-8 bg-primary text-white overflow-hidden flex items-center">
      <div className="overflow-hidden whitespace-nowrap flex-1">
        <div className="inline-flex animate-marquee">
          <Link to="/competition" className="text-[11px] font-bold tracking-widest leading-8">{TICKER_TEXT.repeat(3)}</Link>
          <Link to="/competition" className="text-[11px] font-bold tracking-widest leading-8" aria-hidden="true">{TICKER_TEXT.repeat(3)}</Link>
        </div>
      </div>
      <button
        onClick={onClose}
        aria-label="Close competition ticker"
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white p-1 transition-colors"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}